import React, { useState, useRef, useEffect } from "react";
import { cardsConfigRVO } from "../Utils/constants";
import IconAtomsClose from "../Resources/svg/Icons/IconAtomsClose";
import TitleQuoteForm from "../Components/titleQuoteForm";
import HideInput from "../Components/hide-input";
import limpiarIcon from "../Resources/svg/gl_delete_filled.svg";
import DetailItem from "./detailItem";
import { DualRing } from "react-loading-io";
import AlertNotifications from "../Components/FormElements/AlertNotifications";
import { useDispatch } from "react-redux";
import { alert, stateAlert } from "../Store/simulate/actions";
import moment from "moment";
import TableRequestRVO from "./tableRequestRVO";
import SpinnerTable from "./SpinnerTable";
import CardTablaRequestRVO from "./FormElements/CardTablaRequestRVO";
import { API } from "aws-amplify";
import { downloadXLSX } from "../Utils/utils";

const ModalFormRVO = ({ open, close, id_product }) => {
  const dispatch = useDispatch();
  const initialFilesValues = [
    {
      title: "Archivo",
      value: null,
      titleDate: "Fecha de Carga",
      date: null,
    },
    {
      title: "Archivo",
      value: null,
      titleDate: "Fecha de Carga",
      date: null,
    },
  ];
  const [isLoading, setisLoading] = useState(false);

  const [detailFiles, setDetailFile] = useState(initialFilesValues);
  const elem = useRef(null);
  const [processedRequests, setProcessedRequests] = useState(false);
  const [chargedRem, setChargedRem] = useState(false);
  const [linkPdf, setLinkPdf] = useState("");
  const [tableRequest, setTableRequest] = useState([]);
  const [loadingTableRequest, setLoadingTableRequest] = useState(false);
  const [  nameFile, setNameFile ] = useState();
  const [selectedXMLFile, setSelectedXMLFile] = useState(null);

  const [previousProccessedItems, setPreviousProccessedItems] = useState([]);

  const closeModal = () => {
    close(id_product);
  };

  const setAlert = (type, title, message) => {
    dispatch(stateAlert(true));
    dispatch(
      alert({
        type,
        title,
        message,
      })
    );

    setTimeout(() => {
      dispatch(stateAlert(false));
    }, 2500);
  };

  const inputFileRef = useRef(null);

  const saveValueOfFiles = (fileName, fileValue) => {
    const includesXML = fileName.includes("xml");
    const includesXLSX = fileName.includes("xlsx");

    if (
      (!includesXML && !includesXLSX) ||
      (includesXLSX && !processedRequests)
    ) {
      setDetailFile([...detailFiles]);
      setAlert(
        "error",
        "Archivo inválido",
        "El tipo de archivo seleccionado no es válido."
      );
      return;
    }
    const currentDate = moment().format("DD/MM/YYYY");

    if (includesXML) {
      detailFiles[0].value = fileName;
      detailFiles[0].date = currentDate;
      setSelectedXMLFile(fileValue);
    } else if (includesXLSX) {
      detailFiles[1].value = fileName;
      detailFiles[1].date = currentDate;
      getRemProm(fileValue);
    }

    setDetailFile([...detailFiles]);
  };

  const cleanValueOfFiles = () => {

    if (detailFiles[1].value) {
      detailFiles[1].value = null;
      getRequests(previousProccessedItems);
    }

    else if (detailFiles[0].value) {
      detailFiles[0].value = null;
      setProcessedRequests(false);
    }
    setDetailFile([...detailFiles]);
  };

  const toBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = reject;
    });

  const extractBase64 = (str) => str.split(",")[1];

  const processFile = () => {
    getRequests();
  };

  const getRequests = (previousRequest) => {
    if (previousRequest) {
      setTableRequest(previousRequest);
      return;
    }
    setisLoading(true);
    toBase64(selectedXMLFile).then(async (base64File) => {
      const request = {
        body: { payload: { xmlBase64: extractBase64(base64File), nombreArchivo: detailFiles[0].value } },
      };

      try {
        const response = await API.post(
          "api-vitalicias",
          "/solicitud/xml/carga",
          request
        );
        const {
          payload: { processedItems, nombreArchivo },
        } = response;
        if (processedItems.length > 0) {
          setNameFile(nombreArchivo)
          setTableRequest(processedItems);
          setPreviousProccessedItems(processedItems);
          setProcessedRequests(true);
          setAlert(
            "success",
            "¡Solicicitudes procesadas!",
            "Las solicitudes se han procesado correctamente."
          );
        }
      } catch (err) {
        const {
          response: { data },
        } = err;
        setAlert("error", "Error", data.error.message);
        cleanValueOfFiles();
      }
      setisLoading(false);
    });
  };

  const downloadTemplate = async () => {
    const xmlId = tableRequest[0].xmlId;
    const response = await API.post(
      "api-vitalicias",
      `/solicitud/remuneracion-promedio/archivo/${xmlId}`,
      {}
    );
    const {
      payload: { file },
    } = response;

    downloadXLSX(file, "plantilla_rem_prom");
  };

  const getRemProm = async (fileValue) => {
    setLoadingTableRequest(true);
    toBase64(fileValue).then(async (base64File) => {
      const request = {
        body: { payload: { xlsxBase64: extractBase64(base64File) } },
      };

      try {
        const response = await API.post(
          "api-vitalicias",
          "/solicitud/remuneracion-promedio/carga",
          request
        );
        const {
          payload: { updatedElements },
        } = response;
        if (updatedElements.length > 0) {
          const filterRequests = tableRequest.filter(request => request.estado == 'ingresado' && request.necesitaRemuneracionPromedio == 0);
          setTableRequest([...filterRequests, ...updatedElements]);
          setAlert(
            "success",
            "¡Remuneraciones promedio procesadas!",
            "Las remuneraciones promedio se han procesado correctamente."
          );
        }
      } catch (err) {
        const {
          response: { data },
        } = err;
        setAlert("error", "Error", data.error.message);
        detailFiles[1].value = null;
      }
      setLoadingTableRequest(false);
    });
  };

  const handleQuoteFile = (files) => {
    let fileName = "Seleccione un archivo";
    let fileValue;
    if (files.length !== 0) {
      fileName = files[0].name;
      fileValue = files[0];

      saveValueOfFiles(fileName, fileValue);
    }
    inputFileRef.current.value = null;
  };

  const quotationFiles = async () => {
    setisLoading(true);

    const payload = {
      payload : {
        data: {
        producto: {
        CodProducto: 'RV',
        xmlId: tableRequest[0].xmlId
        }
      }
      }
    }

    const myInit = {
        body: payload,
        headers: {},
    }
      try {
      await API.post(
          'api-vitalicias',
          '/solicitud/cotizacion/rv/xmlMasivo',
          myInit
      )
          .then((response) => {
            setChargedRem(true);
          })
          .catch((error) => {
              console.log('Error: ', error)
          })
  } catch (ex) {
      console.log(ex)
  }
    setisLoading(false)
  };

  const downloadPdf = async () => {
       setisLoading(true);
    const xmlId = tableRequest[0].xmlId;
     const payload = {
      payload : {
        type: 'pdf',
        nombreArchivo: nameFile
      }
    }
    const req = {
      body: payload,
      headers: {},
      }
    try { await API.post(
      "api-vitalicias",
      `/solicitud/remuneracion-promedio/archivo/${xmlId}`,
      req
    ).then((resp) => {
      if(resp){
        setisLoading(false);
        setLinkPdf(resp.payload.documents.fileUrl)
      }
    });}
    catch {
      setisLoading(false);
    }
  }

  useEffect(() => {
    return () => {
      setTimeout(() => {
        setDetailFile(initialFilesValues);

        setisLoading(false);
        setProcessedRequests(false);
        setChargedRem(false);
      }, 500);
    };
  }, [open]);

    useEffect(() => {
      if (linkPdf) {
        elem.current.click();
      }
    }, [linkPdf]);

  return (
    <div className={`modalFormRVO  ${open ? "is-open" : ""}`}>
      <div className="modalFormRVO__container">
        <div className="modalFormRVO__container__button" onClick={closeModal}>
          <span>Cerrar</span>
          <IconAtomsClose />
        </div>
        {!processedRequests && (
          <div className="configHome">
            <TitleQuoteForm
              title={"Rentas Vitalicias Oficiales"}
              subtitle={"Carga de Solicitudes"}
            />
            <div className="configHome__container">
              {cardsConfigRVO.map((item, key) => (
                <HideInput
                  config={item}
                  key={key}
                  handleSendValue={(fileName, fileValue) =>
                    saveValueOfFiles(fileName, fileValue)
                  }
                />
              ))}
              {detailFiles[0].value && (
                <div className="detailsTab">
                  <div className="detailsTab__listDetails">
                    <DetailItem
                      flag={detailFiles[0].title + ": "}
                      details={detailFiles[0].value}
                    />
                    <DetailItem
                      flag={detailFiles[0].titleDate + ": "}
                      details={detailFiles[0].date}
                    />
                  </div>
                  <a
                    onClick={() => cleanValueOfFiles()}
                    className="detailsTab__clearList"
                  >
                    <img src={limpiarIcon} /> Limpiar Datos
                  </a>
                </div>
              )}
            </div>
            <div className="modalFormRVO__action-button">
              <button
                onClick={() => processFile()}
                id="button_quote_vas"
                type="submit"
                className="btn btnew"
                disabled={!detailFiles[0].value}
              >
                Procesar
              </button>
            </div>
          </div>
        )}

        {processedRequests && !chargedRem && (
          <div className="configHome">
            <div className="titleQuoteForm">
              <div className="configFormAS__container-titles">
                <p className="configFormAS__container-titles__title">
                  Archivo de solicitudes cargado:
                </p>
                <div className="titleQuoteForm__subtitle">
                  <DetailItem
                    flag={detailFiles[0].title + ": "}
                    details={detailFiles[0].value}
                  />
                  <DetailItem
                    flag={detailFiles[0].titleDate + ": "}
                    details={detailFiles[0].date}
                  />
                    <DetailItem
                      flag={"Número de solicitudes: "}
                      details={tableRequest.length}
                    />
                </div>
              </div>

              {detailFiles[1].value && (
                <div className="configFormAS__container-titles">
                  <p className="configFormAS__container-titles__title">
                    Archivo de remuneraciones promedio cargado:
                  </p>
                  <div className="titleQuoteForm__subtitle">
                    <DetailItem
                      flag={detailFiles[1].title + ": "}
                      details={detailFiles[1].value}
                    />
                    <DetailItem
                      flag={detailFiles[1].titleDate + ": "}
                      details={detailFiles[1].date}
                    />
                  </div>
                </div>
              )}
            </div>

            <div>
              <div className="content-box">
                {loadingTableRequest && (
                  <>
                    <div className="sectionTable__descktop">
                      <div className="skeleton-table">
                        <SpinnerTable
                          title="¡Danos un momento!"
                          subtitle="Se está cargando la información."
                        />
                      </div>
                    </div>
                    <div className="sectionTable__movile">
                      <SpinnerTable
                        title="¡Danos un momento!"
                        subtitle="Se está cargando la información."
                      />
                    </div>
                  </>
                )}
                {!loadingTableRequest && tableRequest.length > 0 && (
                  <>
                    <div className="sectionTable">
                      <div className="sectionTable__actionButtons">
                        <button
                          className="btn is-secondary is-small"
                          onClick={() => cleanValueOfFiles()}
                        >
                          Cancelar
                        </button>
                        {!detailFiles[1].value && (
                          <>
                            <button
                              className="btn is-small"
                              onClick={() => inputFileRef.current.click()}
                            >
                              Subir Rem. Prom
                            </button>
                            <button
                              className="btn is-small"
                              onClick={downloadTemplate}
                            >
                              Descargar XLSX
                            </button>
                          </>
                        )}
                        { true && (
                          <button
                            className="btn is-small"
                            onClick={() => downloadPdf()}
                            disabled={!detailFiles[0].value}
                          >
                            Descargar PDF
                          </button>
                        )}
                        { true && (
                          <button
                            className="btn is-small"
                            onClick={() => quotationFiles()}
                            disabled={!detailFiles[0].value}
                          >
                            Cotizar
                          </button>
                        )}
                      </div>
                      <a
                        style={{ display: "none" }}
                        target="_blank"
                        rel="noopener noreferrer"
                        href={linkPdf}
                        ref={elem}
                      />
                      <input
                        type="file"
                        ref={inputFileRef}
                        accept=".xlsx"
                        className="hide-input"
                        onChange={(e) => handleQuoteFile(e.target.files)}
                      />
                    </div>
                    <TableRequestRVO data={tableRequest} />
                    {tableRequest.map((datos, index) => (
                      <CardTablaRequestRVO data={datos} key={index} />
                    ))}
                  </>
                )}
              </div>
            </div>
          </div>
        )}

        {chargedRem && processedRequests && (
          <div className="configHome">
            <TitleQuoteForm
              title={"Las cotizaciones se han cargado exitosamente!"}
              subtitle={
                "Le llegará un mensaje de confirmación a su correo electrónico cuando las cotizaciones estén listas."
              }
            />
            <div className="configHome__container"></div>
            <div className="modalFormRVO__action-button">
              <button
                onClick={closeModal}
                id="button_quote_vas"
                type="submit"
                className="btn btnew"
              >
                Continuar
              </button>
            </div>
          </div>
        )}
      </div>

      {isLoading && (
        <div className="loading-field">
          <DualRing size={50} />
        </div>
      )}
      <AlertNotifications />
    </div>
  );
};

export default ModalFormRVO;
